import ErrorIcon from "@mui/icons-material/Error";
import SplitscreenIcon from "@mui/icons-material/Splitscreen";
import ListIcon from "@mui/icons-material/List";
import BarChartIcon from "@mui/icons-material/BarChart";
import DonutLargeIcon from "@mui/icons-material/DonutLarge";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Box, Button, Stack } from "@mui/material";
import React from "react";
import TourIcon from "@mui/icons-material/Tour";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { getAssetsUrl } from "src/utils/url";

const DashboardButton = styled(Button)`
    background-color: ${({ theme }) => theme.palette.background.default};
    font-size: 12px;
    margin-top: 13px;
    z-index: 10;
`;

const NoDataPlaceholder = ({ variant, errorMessage }) => {
    const navigate = useNavigate();
    const assetLink = getAssetsUrl();
    const redirectToMissions = () => {
        return navigate("/missions-personal");
    };
    if (variant === "correlation") {
        return (
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{ height: "100%" }}
            >
                <ListIcon style={{ opacity: "0.2", fontSize: "5rem" }} />
                <span style={{ opacity: "0.2", fontSize: "0.8rem", textAlign: "center" }}>
                    {errorMessage}
                </span>
            </Stack>
        );
    }
    if (variant === "pie") {
        return (
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{ height: "100%" }}
            >
                <DonutLargeIcon style={{ opacity: "0.2", fontSize: "5rem" }} />
                <span style={{ opacity: "0.2", fontSize: "0.8rem", textAlign: "center" }}>
                    No data on selected dates.
                </span>
            </Stack>
        );
    }
    if (variant === "bar") {
        return (
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{ height: "100%" }}
            >
                <BarChartIcon style={{ opacity: "0.2", fontSize: "5rem" }} />
                <span style={{ opacity: "0.2", fontSize: "0.8rem", textAlign: "center" }}>
                    No data on selected dates.
                </span>
            </Stack>
        );
    }
    if (variant === "overview") {
        return (
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{ height: "100%", marginTop: "39px" }}
            >
                <BarChartIcon style={{ opacity: "0.2", fontSize: "5rem" }} />
                <span style={{ opacity: "0.2", fontSize: "0.8rem", textAlign: "center" }}>
                    No data available.
                </span>
            </Stack>
        );
    }
    if (variant === "overview-mini") {
        return (
            <Stack direction="column" justifyContent="center" alignItems="center">
                <WarningAmberIcon style={{ opacity: "0.2", fontSize: "2rem" }} />
                <span style={{ opacity: "0.2", fontSize: "0.8rem", textAlign: "center" }}>
                    Please try again.
                </span>
            </Stack>
        );
    }
    if (variant === "subindex") {
        return (
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{ height: "56%" }}
            >
                <BarChartIcon style={{ opacity: "0.2", fontSize: "3rem" }} />
                <span style={{ opacity: "0.2", fontSize: "0.8rem", textAlign: "center" }}>
                    No data on selected dates.
                </span>
            </Stack>
        );
    }
    if (variant === "dora") {
        return (
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{ height: "100%" }}
            >
                <BarChartIcon style={{ opacity: "0.2", fontSize: "5rem" }} />
            </Stack>
        );
    }
    if (variant === "list") {
        return (
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{ height: "100%" }}
            >
                <ListIcon style={{ opacity: "0.2", fontSize: "5rem" }} />
                <span style={{ opacity: "0.2", fontSize: "0.8rem", textAlign: "center" }}>
                    No data on selected dates.
                </span>
            </Stack>
        );
    }
    if (variant === "tickets")
        return (
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{ height: "100%", marginRight: "24px" }}
            >
                <SplitscreenIcon style={{ opacity: "0.2", fontSize: "3rem" }} />
                <span style={{ opacity: "0.2", fontSize: "0.8rem", textAlign: "center" }}>
                    Seems like you have no tickets on selected dates.
                </span>
            </Stack>
        );
    if (variant === "summary-missions")
        return (
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{ height: "100%", margin: "24px" }}
            >
                <SplitscreenIcon style={{ opacity: "0.2", fontSize: "3rem" }} />
                <span style={{ opacity: "0.2", fontSize: "0.8rem", textAlign: "center" }}>
                    Seems like you have not completed any missions last week.
                </span>
            </Stack>
        );
    if (variant === "summary-achievements")
        return (
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{ height: "100%", margin: "24px" }}
            >
                <SplitscreenIcon style={{ opacity: "0.2", fontSize: "2rem" }} />
                <span style={{ opacity: "0.2", fontSize: "0.8rem", textAlign: "center" }}>
                    Seems like you have no achievements for last week.
                </span>
            </Stack>
        );
    if (variant === "summary")
        return (
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{ height: "100%", marginRight: "24px" }}
            >
                <Box
                    component="img"
                    sx={{
                        height: "120px",
                        width: "120px",
                        borderRadius: "12px",
                        mixBlendMode: "exclusion",
                    }}
                    src={`${assetLink}/summary/noDataSummaryLg.png`}
                    loading="lazy"
                    alt=""
                />
                <span style={{ opacity: "0.4", fontSize: "0.8rem", textAlign: "center" }}>
                    No goals or achievements last week
                </span>
                <DashboardButton
                    variant="outlined"
                    color="secondary"
                    onClick={(e) => {
                        e.stopPropagation();
                        redirectToMissions();
                    }}
                    startIcon={<TourIcon />}
                    style={{
                        textDecoration: "auto",
                        textAlign: "center",
                        paddingRight: "12px",
                    }}
                >
                    create mission
                </DashboardButton>
            </Stack>
        );
    if (variant === "no-summary")
        return (
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{ height: "100%", marginRight: "24px" }}
            >
                <Box
                    component="img"
                    sx={{
                        height: "120px",
                        width: "120px",
                        borderRadius: "12px",
                        mixBlendMode: "exclusion",
                    }}
                    src={`${assetLink}/summary/noDataSummaryLg.png`}
                    loading="lazy"
                />
                <span style={{ opacity: "0.4", fontSize: "0.8rem", textAlign: "center" }}>
                    No summary has been generated yet. Please look back on Monday!
                </span>
            </Stack>
        );
    return (
        <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            style={{ height: "100%" }}
        >
            <ErrorIcon style={{ opacity: "0.2", fontSize: "5rem" }} />
            <span style={{ opacity: "0.2", fontSize: "0.8rem", textAlign: "center" }}>
                No data on selected dates.
            </span>
        </Stack>
    );
};

export default NoDataPlaceholder;
